export default __webpack_public_path__ + "eec81dc5f19257f92221450db8eb5b4e.png";